import React from 'react'
import dek from '../../Assets/dek.png';
import florist from '../../Assets/florist.png';
import cycle from '../../Assets/cycle.png';
import transteel from '../../Assets/transteel.jpg';
import al from '../../Assets/al.png';
import drn from '../../Assets/DRN.jpeg';






function Clients() {

  const images = [dek,florist,cycle,transteel,al,drn ]

  return (
    <div  className="w-[78%] flex flex-col gap-10 xl:mt-20 2xl:mt-24 text-center items-center">       
    <span className='bold text-[20px] sm:text-[24px] lg:text-[30px]'>Trusted by local businesses & leading brands across the world</span>
    <div className='min-h-[100px] w-full flex justify-center flex-wrap lg:flex-nowrap gap-10 mt-10'>
       {
        images.map((e) => (
          <img className='aspect-auto h-[80px] ' src={e} alt="" />
        ))
       }
    </div>
  </div>
  )
}

export default Clients
